import config from '../config.jsx';

export const logdebug = (...mensagem) => {
    // Captura o nome da função que chamou logdebug
    const stackLine = (new Error()).stack.split('\n')[2] || '';
    // Tenta extrair o nome da função (ex: gao0008gb)
    const callerMatch = stackLine.match(/at (\w+)/);
    const callerName = callerMatch ? callerMatch[1] : 'unknown';
    mensagem.unshift(`caller: ${callerName}`);
    if (config.DEBUG) {
        console.log('logdebug', ...mensagem);
    }
}